import * as types from './mutation_types'

export default {
  [types.LOAD_DEGREE_PROGRAMS](state, degreePrograms) {
    state.degreePrograms = degreePrograms
  },

  [types.LOAD_USER_DEGREE_TYPE](state, userDegreeType) {
    state.userDegreeType = userDegreeType
  },

  [types.LOAD_MILITARY_STATUS](state, militaryStatus) {
    state.militaryStatus = militaryStatus
  },

  [types.LOAD_DEGREE_OPTIONS](state, degreeOptions) {
    state.degreeOptions = degreeOptions
  },

  [types.LOAD_COURSE_MODALITY](state, courseModality) {
    state.courseModality = courseModality
  },

  [types.LOAD_REGIONS](state, regions) {
    state.regions = regions
  },

  [types.LOAD_SCHOOL_SIZE](state, schoolSize) {
    state.schoolSize = schoolSize
  },

  [types.LOAD_HBCU_OPTIONS](state, hbcuOptions) {
    state.hbcuOptions = hbcuOptions
  },

  [types.LOAD_NOTIFICATIONS](state, notifications) {
    state.notifications = notifications
  },

  [types.SET_SDN_AGREE](state, sdnAgree) {
    state.userSdnAgree = sdnAgree
  },

  [types.SET_DISCOUNT_NUMBER](state, discountNumber) {
    state.discountNumber = discountNumber
  },
}
